import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import { ApplicationState } from '../../reducers';
import { getSelectedBrandCode } from '../../selectors/brand/brandSelector';
import { getSelectedItems } from '../../selectors/catalogue/catalogueSelector';
import { intercomEvent } from '../../utils/IntercomUtils';
import { hasPermission } from '../../utils/Permissions';
import CustomAppsEmbedded from '../../components/body/settings/customApps/CustomAppsEmbedded';
import ItemInfo from '../../components/global/ItemInfo';
import Page from '../../components/global/page/Page';

const ProductSingleCustomAppContainer: React.FC = () => {
  const { t } = useTranslation();
  const { appId } = useParams<{ appId: string }>();

  const user = useSelector((state: ApplicationState) => state.user.user);
  const brandCode = useSelector((state: ApplicationState) => getSelectedBrandCode(state));
  const selectedItems = useSelector((state: ApplicationState) => getSelectedItems(state));
  const brandId = useSelector((state: ApplicationState) => state.parent.brands.selectedBrandId);

  const canAccessCustomApps = useMemo(() => hasPermission(user, 'can_access_replit'), [user]);

  React.useEffect(() => {
    intercomEvent('viewed-custom-apps');
  }, []);

  if (!canAccessCustomApps) {
    return (
      <Page>
        <div className="p-5">
          <Alert
            showIcon
            type="info"
            message={t('common:noAccess')}
            description={t('replit:noPermission')}
          />
        </div>
      </Page>
    );
  }

  if (selectedItems.length > 1 || selectedItems.length === 0) {
    return <ItemInfo items={selectedItems} />;
  }

  const selectedItem = selectedItems[0];

  return (
    <Page>
      <CustomAppsEmbedded
        productId={selectedItem.id}
        partNumber={selectedItem.part_number}
        brandId={brandId}
        brandCode={brandCode}
        appId={Number(appId)}
        hideAppSelector
      />
    </Page>
  );
};

export default ProductSingleCustomAppContainer;
